import PropTypes from 'prop-types';
import React, { useState } from 'react';
import AidRect from './aidRectCheckbox.module.scss';
import rectCheckboxContext from '../../utils/rectCheckboxContext';
import TestPng from '../../assets/test.png';

function AidRectCheckbox(props) {
  const {
    icon, index, text, checked, style, unit, onChange,
  } = props;

  const {
    width, height, fontSize = '14',
  } = style;

  const containerHeight = height || width;
  const [focus, setFocus] = useState(false);
  const context = React.useContext(rectCheckboxContext);
  const checkedIcon = () => {
    if (checked) {
      return (
        <div
          className={focus ? AidRect['aid-checked-focus-icon'] : AidRect['aid-checked-icon']}
          style={{
            width: `${0.22 * width}${unit}`,
            height: `${0.22 * width}${unit}`,
            top: `${0.08 * width}${unit}`,
            right: `${0.08 * width}${unit}`,
          }}
        />
      );
    }
    return (<></>);
  };
  const onBlur = () => {
    setFocus(false);
  };

  return (
    <div
      role="button"
      tabIndex="0"
      className={`${checked ? AidRect['aid-bc-checked'] : AidRect['aid-bc-unchecked']} ${AidRect['aid-bc-container']}`}
      style={{ width: `${width}${unit}`, height: `${containerHeight}${unit}` }}
      onClick={
        () => {
          setFocus(true); onChange(index); if (context.onChange) { context.onChange(index); }
        }
      }
      onBlur={() => onBlur()}
      aria-hidden
    >
      <div
        style={
          {
            width: `${width}${unit}`,
            height: `${containerHeight * 0.375}${unit}`,
            top: `${width / 4.57}${unit}`,
          }
        }
        className={AidRect['aid-icon-container']}
      >
        {icon}
        {/* <img alt="" src="/src/assets/test.png" /> */}
      </div>
      {checkedIcon()}
      <span
        className={AidRect['checkbox-text']}
        style={{
          bottom: `${width / 8.5}${unit}`,
          fontSize: `${fontSize}`,
        }}
      >
        {text}
      </span>
    </div>
  );
}

AidRectCheckbox.propTypes = {
  icon: PropTypes.element,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  index: PropTypes.string,
  text: PropTypes.string,
  style: PropTypes.objectOf(PropTypes.any),
  unit: PropTypes.string,
};
AidRectCheckbox.defaultProps = {
  icon: (<img alt="" src={TestPng} />),
  checked: false,
  onChange: () => {},
  index: '',
  text: '',
  style: {},
  unit: 'rem',
};

export default AidRectCheckbox;
